/* eslint-disable @typescript-eslint/naming-convention */
export abstract class UI_ACTION_CONSTANTS {
  static readonly OER_CONVERSION_PROCESS_STARTED: string = "oerConversionProcessStarted";
  static readonly OER_CONVERSION_PROCESS_FINISHED: string = "oerConversionProcessFinished";

  static readonly FIRST_STEPS_DIALOG_STARTED: string = "firstStepsDialogStarted";
  static readonly FIRST_STEPS_DIALOG_FINISHED: string = "firstStepsDialogFinished";

  static readonly FILE_IMPORTED: string = "fileImported";
  static readonly USERNAME_ENTERED: string = "usernameEntered";
  static readonly TARGET_LICENSE_SELECTED: string = "targetLicenseSelected";
  static readonly LEGAL_DISCLAIMER_ENTERED: string = "legalDisclaimerEntered";

  static readonly IMAGE_SELECTED: string = "imageSelected";
  static readonly IMAGE_EDITED: string = "imageEdited";
  static readonly IMAGE_REPLACED: string = "imageReplaced";

  static readonly EXTERNAL_IMAGE_AUTO_QUERIED: string = "externalImageAutoQueried";
  static readonly EXTERNAL_IMAGE_SEARCHED: string = "externalImageSearched";
  static readonly EXTERNAL_IMAGE_FETCHED: string = "externalImageFetched";

  static readonly REPLACED_IMAGE_UNDID: string = "replacedImageUndid";

  static readonly FEEDBACK_SUBMITTED: string = "feedbackSubmitted";
};

export abstract class REPLACEMENT_ACTION_CONSTANTS {
  static readonly EXTERNAL_SEARCH: string = "externalSearch";
  static readonly PUBLISH_AS_OER: string = "publishAsOER";
  static readonly MANUAL_REPLACEMENT: string = "manualReplacement";
  static readonly EXCLUDE_FROM_LICENSE: string = "excludeFromLicense";
};
